import { render, staticRenderFns } from "./CalloutBanner.vue?vue&type=template&id=2a670444"
import script from "./CalloutBanner.vue?vue&type=script&lang=ts"
export * from "./CalloutBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports